import { css } from 'linaria';

export const reviewsBenefitsList = css`
  display: flex;
  padding: 0;
  margin: 0;
  margin-bottom: 68px;
  width: 100%;
  justify-content: space-between;
  list-style: none;

  @media (--to-desktop) {
    flex-direction: column;
    row-gap: 16px;
  }

  @media (--only-mobile) {
    margin-bottom: 40px;
  }
`;

export const reviewsBenefitsItem = css`
  display: flex;
  align-items: center;
  column-gap: 12px;

  @media (--only-mobile) {
    column-gap: 8px;
  }
`;

export const reviewsBenefitsItemNewVariant = css`
  @media (--from-desktop) {
    align-items: flex-start;
  }
`;

export const reviewsBenefitsIcon = css`
  && {
    @media (--only-mobile) {
      width: 32px;
      height: 32px;
    }
  }
`;

export const reviewsBenefitsText = css`
  @media (--from-desktop) {
    white-space: break-spaces;
  }
`;
